import { render, staticRenderFns } from "./oneviewDashboard.vue?vue&type=template&id=0f83c44c&scoped=true"
import script from "./oneviewDashboard.vue?vue&type=script&lang=ts"
export * from "./oneviewDashboard.vue?vue&type=script&lang=ts"
import style0 from "./oneviewDashboard.vue?vue&type=style&index=0&id=0f83c44c&prod&lang=scss&scoped=true"
import style1 from "./oneviewDashboard.vue?vue&type=style&index=1&id=0f83c44c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f83c44c",
  null
  
)

export default component.exports